import { api as config } from '../../../global/config/api';

// TSS vite/04 §"Endpoint paths" — relative strings, no leading slash, for the
// axios instance. The stream is the exception and says why below.

// The pulse owns the event log and the channel. The lists it reads names from
// are catalogs shared with other screens and live in global/contexts/lookups.
export const livePaths = {
    events: () => 'admin/events',
    // The notice travels without author or `data` (T15.5): the rest is asked
    // for here, by the id the notice brings.
    event:  (id) => `admin/events/${id}`,
    // Read for `pagination.total` only, one state at a time: the graph needs a
    // number per node and the list endpoint carries an exact count on every
    // answer, so a `limit=1` page is the cheapest true count there is.
    tasks:  () => 'admin/tasks',
};

// EventSource takes an absolute URL: it is not an axios call and knows nothing
// about baseURL. Built from the same VITE_API_ENDPOINT every other request
// uses (TSS vite/06 [RIGID] — no URL is written in source).
//
// The route is `GET /api/v1/events/stream`, published by T15.2. It is NOT
// under /admin: the channel serves a person's session or an agent's token.
//
// `types` carries the FAMILY (`task.*`) and not the nine exact kinds, because
// asking for the exact kinds is refused — T15.4 validates them against the
// events that have already occurred. The full reasoning, and the cost, is on
// STREAM_TYPES in utils/flow.js.
export function streamUrl({ projectId, types } = {}) {
    const url = new URL(`${config.endpoint}/events/stream`, window.location.origin);
    if (projectId) url.searchParams.set('project', String(projectId));
    if (types) url.searchParams.set('types', types);
    return url.toString();
}
